// extracted by mini-css-extract-plugin
export var bullet = "SliderPagination-module--bullet--dc647";
export var bulletActive = "SliderPagination-module--bulletActive--39c8a";
export var buttonInner = "SliderPagination-module--buttonInner--a3a2a";
export var pagination = "SliderPagination-module--pagination--ee46b";
export var paginationItem = "SliderPagination-module--paginationItem--4335d";
export var paginationList = "SliderPagination-module--paginationList--88cf3";